// extracted by mini-css-extract-plugin
module.exports = {"invitationList":"InvitationList_invitationList__3gvvC"};